import React from 'react';
import { Link } from 'react-router-dom';

class Menu extends React.Component {

    constructor() {
        super();
        this.sair = this.sair.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    sair() {
        localStorage.removeItem("usuarioInfo");
        localStorage.removeItem("auth");
        localStorage.removeItem("successMsg");
        localStorage.removeItem("roleUsuarios");
        localStorage.removeItem("roleCentros");
        localStorage.removeItem("roleEstoque");
        localStorage.removeItem("roleContas");
        localStorage.removeItem("roleMovimentacoes");
        localStorage.removeItem("roleRelatorios");
        window.location.href = "/";
    }

    toggle() {
        this.props.setToggle();
    }

    render() {
        return (
            <div id={ "dashboard-menu-" + this.props.toggle }>
                <button id="dashboard-toggle-btn" onClick={ this.toggle }>&#9776;</button>
                <div id={ "dashboard-menu-toggle-" + this.props.toggle }>
                    <h1 id="dashboard-titulo">Sistema Caeté</h1>
                    <ul>
                        <li><Link to="/home"><div><span>Início</span></div></Link></li>

                        { localStorage.roleUsuarios !== "nenhuma" &&
                            <li><Link to="/usuarios"><div><span>Usuários</span></div></Link></li> }

                        { localStorage.roleCentros !== "nenhuma" &&
                            <li><Link to="/centros"><div><span>Centros de Custo</span></div></Link></li> }

                        { localStorage.roleEstoque !== "nenhuma" &&
                            <li><Link to="/estoque"><div><span>Estoque</span></div></Link></li> }

                        { localStorage.roleContas !== "nenhuma" &&
                            <li><Link to="/contas"><div><span>Contas</span></div></Link></li> }

                        { localStorage.roleMovimentacoes !== "nenhuma" &&
                            <li><Link to="/movimentacoes"><div><span>Movimentações</span></div></Link></li> }

                        { localStorage.roleRelatorios !== "nenhuma" &&
                            <li><Link to="/relatorios"><div><span>Relatórios</span></div></Link></li> }

                        <li><p onClick={this.sair}><div><span>Sair</span></div></p></li>
                    </ul>
                </div>
            </div>
        );
    }

}

export default Menu;

